import { GlobalOutlined } from '@ant-design/icons';
import { Dropdown, Space } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
    { label: '🇬🇧', key: 'en' },
    { label: '🇫🇷', key: 'fr' },
    { label: '🇩🇪', key: 'de' },
    { label: '🇪🇸', key: 'es' },
    { label: '🇮🇹', key: 'it' }
];

function LanguageSelector({ kernel }) {
    const { t, i18n } = useTranslation();
    const [language, setLanguage] = useState(i18n.language);

    const currentFlag = languages.find(lng => lng.key === language)?.label || '🌐';

    const onClick = async ({ key }) => {
        setLanguage(key);
        i18n.changeLanguage(key);
        
        if (kernel?.api) {
            await kernel.api.post('/user/update', { lang: key });
        }
    };

    const items = languages.map(lng => ({
        ...lng,
        label: `${lng.label} ${t(`Language.${lng.key}`)}`
    }));

    return (
        <Dropdown
            trigger={['click']}
            menu={{ items, onClick }}
        >
            <a
                onClick={(e) => e.preventDefault()}
                style={{ cursor: 'pointer' }}
            >
                <Space style={{ color: "#000" }}>
                    <GlobalOutlined />
                    <span style={{ fontSize: 16 }}>{currentFlag}</span>
                </Space>
            </a>
        </Dropdown>
    );
}

export default LanguageSelector;